import { frontendURL } from '../../../../helper/URLHelper';

const kanban = accountId => (
  {
    parentNav: 'kanban',
    routes: ['kanban_board'],
    key: 'kanban',
    icon: 'kanban-outline',
    label: 'KANBAN',
    hasSubMenu: false,
  },
  {
    parentNav: 'task-list',
    routes: ['task-list_board'],
    key: 'task-list',
    icon: 'clipboard-task-list-outline',
    label: 'TASK LIST',
    hasSubMenu: false,
  }, 
  {
    parentNav: 'notepad',
    routes: ['notepad_board'],
    key: 'notepad',
    icon: 'notepad-solid',
    label: 'NOTEPAD',
    hasSubMenu: false,
  }
);

export default kanban; 